import React from 'react';

import snackInit from 'constants/snackInit';

export default React.createContext(snackInit);
